// src/data/projectsData.js

const projectsData = [
  {
    id: 1,
    title: "SprayGround KW",
    image: "https://res.cloudinary.com/doacbhqcl/image/upload/v1752400397/SG_ej4cir.jpg",
    url: "https://www.behance.net/gallery/204690591/Sprayground-Bags-Social-Media-Posts"
  },
  {
    id: 2,
    title: "Perfeccion Perfumes KW",
    image: "https://res.cloudinary.com/doacbhqcl/image/upload/v1752400410/PR_imp8qe.jpg",
    url: "https://www.behance.net/gallery/177368561/Prefeccion-perfume-store-product-social-media-posters"
  },
  {
    id: 3,
    title: "Premiume Foods KW",
    image: "https://res.cloudinary.com/doacbhqcl/image/upload/v1752400385/PF_rnyr62.jpg",
    url: "https://www.behance.net/gallery/209007893/Premiume-Foods-KW-Social-Media-posts"
  },
    {
    id: 4,
    title: "Petcare KW",
    image: "https://res.cloudinary.com/doacbhqcl/image/upload/v1752401529/PC_wt13yy.jpg",
    url: "https://www.behance.net/gallery/177090271/Pet-care-vet-store-social-media-posters"
  },
  {
    id: 5,
    title: "Almarfoo School SY",
    image: "https://res.cloudinary.com/doacbhqcl/image/upload/v1769798912/MS_nkcc9s.jpg",
    url: "https://www.behance.net/gallery/240778669/AlMarfoo-Virtual-School-Social-Media"
  },
  {
    id: 6,
    title: "SKY 4Q SY",
    image: "https://res.cloudinary.com/doacbhqcl/image/upload/v1769861709/S4_qrd8in.jpg",
    url: "https://www.behance.net/gallery/243266339/SKY-4Q-Social-Media"
  },
];

export default projectsData;